import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { assetStateClassNameConfig } from './AssetStateClass.name';

enum AssetStateClass {
  normal = 'NORMAL',
  retired = 'RETIRED',
}

const assetStateClassMap = new Map([
  ['NORMAL', AssetStateClass.normal],
  ['RETIRED', AssetStateClass.retired],
]);

const rawValueToAssetStateClass = rawValueToEnumWithDefault(assetStateClassMap, AssetStateClass.normal);

const assetStateClassToDisplay = enumToNameWithDefault(AssetStateClass, assetStateClassNameConfig);

const assetStateClassToDisplayWithPrefix = enumToNameWithDefault(
  AssetStateClass,
  assetStateClassNameConfig,
  true,
);

export {
  AssetStateClass,
  assetStateClassMap,
  assetStateClassToDisplay,
  assetStateClassToDisplayWithPrefix,
  rawValueToAssetStateClass,
};
